export default __webpack_public_path__ + "static/media/wrong2.f59b6902.png";